import React from 'react';
import { Grid } from './styles';
import GridCard from './_GridCard';
import { AccProps } from './_AccessorySlider';

interface AccGridProps extends AccProps {
  reverse?: boolean;
  accessories: any;
}

const AccGrid = ({ accessories, reverse }: AccGridProps) => {
  return (
    accessories && (
      <Grid>
        {accessories.map((accessory: any, i: any) => (
          <GridCard {...accessory} key={i} reverse={reverse} />
        ))}
      </Grid>
    )
  );
};

export default AccGrid;
